// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-page-pre-ltp .logo-container {
  justify-content: center;
}

.page-pre-ltp .icon-container {
  margin-top: 100px;
  text-align: center;
}

.page-pre-ltp .icon-container svg {
  display: inline-block;
}

.page-pre-ltp .page-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  margin: 24px 0 10px;
}

.page-pre-ltp .page-description {
  text-align: center;
  color: #494949;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/pre-ltp.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".header-page-pre-ltp .logo-container {\n  justify-content: center;\n}\n\n.page-pre-ltp .icon-container {\n  margin-top: 100px;\n  text-align: center;\n}\n\n.page-pre-ltp .icon-container svg {\n  display: inline-block;\n}\n\n.page-pre-ltp .page-title {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 28px;\n  margin: 24px 0 10px;\n}\n\n.page-pre-ltp .page-description {\n  text-align: center;\n  color: #494949;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
